import { ChevronDown } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgArrowButtonDown1 = mkIcon(ChevronDown);